import type { WireTypes } from '@flakiness/server/common/wireTypes.js';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('fk-pr-icon')
class FKPullRequestIcon extends LitElement {
  @property() state?: WireTypes.PullRequestState;

  override render() {
    if (!this.state)
      return nothing;
    const icon = this.state === 'merged' ? html`<sl-icon library=boxicons name=bx-git-merge></sl-icon>` :
      this.state === 'closed' ? html`<sl-icon src='/git-pull-request-closed.svg'></sl-icon>` :
      html`<sl-icon library=boxicons name=bx-git-pull-request></sl-icon>`;
    return html`<span class=${this.state}>${icon}</span>`;
  }

  static styles = css`
    span {
      display: flex;
    }

    .open {
      color: green;
    }

    .merged {
      color: #9c27b0;
    }

    .closed {
      color: red;
    }
  `;
}
